import React from 'react';
import GlobeIcon from '../../icons/IconLib/GlobeIcon';
import OptionSelect, { IOption } from './OptionSelect';

/** Значения ZPL-параметра ChangeInternationalEncodingZPL. */
export const ZPL_ENCODING = {
    HEBREW_28: 28,
    NONE_0: 0,
    UTF8_36: 36,
} as const;

export type ZplEncodingValue = typeof ZPL_ENCODING[keyof typeof ZPL_ENCODING];

const ZPL_ENCODING_OPTIONS: IOption[] = [
    { value: ZPL_ENCODING.HEBREW_28, label: '28' },
    { value: ZPL_ENCODING.NONE_0, label: '0' },
    { value: ZPL_ENCODING.UTF8_36, label: '36' },
];

interface Props {
    value: ZplEncodingValue | number;
    onSelect: (value: ZplEncodingValue) => void;
    placeholder?: string;
    disabled?: boolean;
    readOnly?: boolean;
    leadingIcon?: React.ReactNode | null;
    className?: string;
}

const ZplEncodingSelector: React.FC<Props> = ({
    value,
    onSelect,
    placeholder = 'קידוד',
    disabled,
    readOnly,
    leadingIcon,
    className,
}) => (
    <OptionSelect
        options={ZPL_ENCODING_OPTIONS}
        value={ZPL_ENCODING_OPTIONS.find((o) => o.value === value) ?? null}
        onSelect={(o) => onSelect((o?.value ?? ZPL_ENCODING.UTF8_36) as ZplEncodingValue)}
        placeholder={placeholder}
        disabled={disabled}
        readOnly={readOnly}
        leadingIcon={leadingIcon === undefined ? <GlobeIcon /> : leadingIcon}
        className={className}
    />
);

export default ZplEncodingSelector;
